import { render, staticRenderFns } from "./setMenupage.vue?vue&type=template&id=4cebacf3&scoped=true"
import script from "./setMenupage.vue?vue&type=script&lang=js"
export * from "./setMenupage.vue?vue&type=script&lang=js"
import style0 from "./setMenupage.vue?vue&type=style&index=0&id=4cebacf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cebacf3",
  null
  
)

export default component.exports